var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5778 4H15.5556V6.44444H18V7.42222H15.5556V9.86666H14.5778V7.42222H12.1333V6.44444H14.5778V4ZM9.38799 7.40003L7.44513 5.48892H2.97143C2.9639 5.48892 2.95875 5.49029 2.95479 5.49195C2.95063 5.49368 2.94708 5.49607 2.94444 5.49849V15.0349C2.94708 15.0373 2.95063 15.0397 2.95479 15.0414C2.95875 15.0431 2.9639 15.0445 2.97143 15.0445H14.6286C14.6361 15.0445 14.6412 15.0431 14.6452 15.0414C14.6493 15.0397 14.6529 15.0373 14.6555 15.0349V10.9333H15.6V15.0445C15.6 15.57 15.1628 16 14.6286 16H2.97143C2.43714 16 2 15.57 2 15.0445V5.48892C2 4.96337 2.43714 4.53337 2.97143 4.53337H7.82856L9.77142 6.44447H11.0667V7.40003H9.38799Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTeam);
export default __webpack_public_path__ + "static/media/new-team.22fab3d39a4c1424fd6bf334feaaa357.svg";
export { ForwardRef as ReactComponent };